/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { POPOVER_DIRECTIVES } from "./index";
var ClrCommonPopoverModule = (function () {
    function ClrCommonPopoverModule() {
    }
    return ClrCommonPopoverModule;
}());
export { ClrCommonPopoverModule };
ClrCommonPopoverModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [POPOVER_DIRECTIVES],
                exports: [POPOVER_DIRECTIVES]
            },] },
];
/** @nocollapse */
ClrCommonPopoverModule.ctorParameters = function () { return []; };
//# sourceMappingURL=popover.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/common/popover.module.js
// module id = 41
// module chunks = 4